export default "__VITE_ASSET__CX5y1yb4__"